import remoteLoad from '@/utils/remoteLoad.js';
import { jsPDF } from "jspdf";

export default {
  data() {
    return {
      // 报名活动的ID
      signupNoticeId: this.$route.query.signupNoticeId,
      // 预报名号
      studentSignupId: this.$route.query.studentSignupId,
      // 幼儿身份证号
      idCard: this.$route.query.idCard,
      applyData: null,
      errMessage: ''
    };
  },
  async mounted() {
    this.ajaxSearchSignupApplyInfo({
      studentSignupId: this.studentSignupId,
      idCard: this.idCard
    });
  },
  created() {
  },
  methods: {
    async ajaxSearchSignupApplyInfo(params) {
      // 查询报名信息 #李茹钰/2019-03-12#
      let { error, data } = await this.$ajax.gateway('/bm-kids/IStudentSignupApi_searchApply', params);
      console.log('-> data data', error, data);
      if (!error && data.code === 200) {
        data = data.data;
        console.log('-> 查询报名信息', data);
        this.applyData = data;
        setTimeout(() => {
          this.initPdfEvent();
        }, 100);
      }
    },
    onClickChangeBtn() {
      // 修改报名信息
			sessionStorage.removeItem('autoPushStep');
			// 更新最新的预约时间
			sessionStorage.setItem('form_orderDate', this.applyData.orderDate);
      this.$router.push({
        path: 'bm_form',
        query: {
          signupNoticeId: this.signupNoticeId,
          studentSignupId: this.studentSignupId,
					idCard: this.idCard,
					orderDate: this.applyData.orderDate
        }
      });
    },
    async initPdfEvent() {
      if (!window.html2canvas) {
        // 同步载入jsPDF
        await remoteLoad('https://linwalker.github.io/render-html-to-pdf/js/html2canvas.js');
      }
      let name = this.applyData.name;
      let registId = this.applyData.id;

      let downPdf = document.getElementById('renderPdf');
      const target = document.getElementById('appData')
      console.log("-> target", target);
      downPdf.onclick = function() {
        console.log('-> downPdf click');
        html2canvas(target, {
          onrendered: function(canvas) {
            let contentWidth = canvas.width;
            let contentHeight = canvas.height;

            //一页pdf显示html页面生成的canvas高度;
            let pageHeight = contentWidth / 592.28 * 841.89;
            //未生成pdf的html页面高度
            let leftHeight = contentHeight;
            //页面偏移
            let position = 0;
            //a4纸的尺寸[595.28,841.89]，html页面生成的canvas在pdf中图片的宽高
            let imgWidth = 595.28;
            let imgHeight = 592.28/contentWidth * contentHeight;


            console.log('-> downPdf onrendered');
            // console.log(canvas);
            // 返回图片dataURL，参数：图片格式和清晰度(0-1)
            var pageData = canvas.toDataURL('image/jpeg', 1.0);
            // 方向默认竖直，尺寸ponits，格式a4[595.28,841.89]
            let pdf = new jsPDF('', 'pt', 'a4');
            // let pdf = new jsPDF('landscape', 'pt', [420, 334]);
            // addImage后两个参数控制添加图片的尺寸，此处将页面高度按照a4纸宽高比列进行压缩
            pdf.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight );
            // pdf.addImage(pageData, 'JPEG', 0, 0, 420, 334 );
            // pdf.addImage(pageData, 'PNG', 0, 0, 503, 400 );

            pdf.save(name + '-'+ registId + '.pdf');
          }
        })
      }
    }
  }
};
